<div style="display: flex; justify-content: center; padding-top: 20px;background: #0E0D0D;"
  class="floor_plan_container">
  <mat-button-toggle-group name="layout" [(value)]="mode">
    <mat-button-toggle value="manage" (change)="changeMode($event)">
      Manage floor plan
    </mat-button-toggle>
    <mat-button-toggle value="upload" (change)="changeMode($event)">
      Upload floor plan
    </mat-button-toggle>
  </mat-button-toggle-group>
</div>
<div #uploadFloorPlan *ngIf="mode === 'upload'" style="padding: 20px 40px 40px 40px;background: #0E0D0D;">
  <mat-horizontal-stepper [linear]="true">
    <mat-step [stepControl]="newFloorPlanForm" completed="false">
      <ng-template matStepLabel>
        Upload Floor Plan
      </ng-template>
      <p>Attention: Each floor plan may contain one or more images. You can only select one image (max size 3MB) when
        creating a new floor
        plan. You can add more images to this floor plan later.</p>
      <p>The max length for file name is 255 characters.</p>
      <div style="width: 300px; margin-top: 10px">
        <form [formGroup]="newFloorPlanForm" fxLayout="column">
          <input #fileInput accept="image/*" type="file" multiple="" (change)="onFileChange($event)">
          <p *ngIf="isFileNameValid === false" style="color: #f44336; font-size: 14px">Image size cannot exceed 3MB and
            image name length can cannot exceed 255 characters.</p>
          <mat-form-field appearance="outline" style="margin-top: 10px">
            <mat-label>Notes</mat-label>
            <textarea matInput formControlName="notes" style="height: 100px" required></textarea>
            <mat-error *ngIf="newFloorPlanForm.invalid" style="margin-top: 20px">
              Notes is required and cannot exceed 200 characters.
            </mat-error>
          </mat-form-field>
          <button mat-button matStepperNext type="button"
            [disabled]="selectedFloorPlans.length < 1 || this.newFloorPlanForm.invalid || isUploading"
            [ngClass]="{'deactivated': selectedFloorPlans.length === 0 || isUploading || this.newFloorPlanForm.invalid, 'activated': selectedFloorPlans.length !== 0 && !isUploading && !this.newFloorPlanForm.invalid}"
            style="background: rgb(43, 113, 255); color: white; width: fit-content; margin-top: 35px"
            (click)="uploadFloorPlans()">
            {{isUploading ? 'Uploading...' : 'Upload'}}
          </button>
        </form>
      </div>
    </mat-step>
    <mat-step [stepControl]="newARModelForm" completed="false">
      <ng-template matStepLabel>
        Upload AR model
      </ng-template>
      <app-new-ar-model [selectedFloorPlanId]="newFloorPlanId"></app-new-ar-model>
    </mat-step>
  </mat-horizontal-stepper>


  <!--    <img *ngFor='let url of images'  [src]="url" height="150" width="200px" style="margin: 3px;"> <br/>-->

  <!--  <ng-container *ngIf="selectedFloorPlans.length > 0">-->
  <!--    <p *ngFor="let file of selectedFloorPlans" style="display: flex; align-items: center; margin-top: 0px">-->
  <!--      <mat-icon style="color: #b7b7b7; margin-right: 5px">insert_drive_file</mat-icon>-->
  <!--      {{file.name}} ({{(file.size / 1048).toFixed(0)}} KB)-->
  <!--    </p>-->
  <!--  </ng-container>-->

</div>
<div *ngIf="mode === 'manage'" style="padding: 20px 40px 40px 40px;background: #0E0D0D;color: #dedede;">
  <div *ngIf="project.floorPlans && project.floorPlans.length > 0">
    <h4>Add more image to floor plan</h4>
    <p>Each image cannot exceed 3M.</p>
    <form [formGroup]="reactiveForm" #formDirective='ngForm'
      style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 20px">
      <mat-form-field appearance="outline" style="width: 300px">
        <mat-label>Choose a floor plan</mat-label>
        <mat-select formControlName="floorPlanId" required>
          <div *ngFor="let floorPlan of this.project.floorPlans">
            <mat-option [value]=floorPlan.id>
              {{floorPlan.notes}}
            </mat-option>
          </div>

        </mat-select>
      </mat-form-field>
      <div>
        <input type="file" accept="image/*" #addtionalImage (change)="additionalImageSelected($event)" required>
        <p style="margin-bottom: 0; margin-top: 5px; color: #f44336; font-size: 12px"
          *ngIf="isAddtionalFileNameValid === false">Image size cannot exceed 3MB.</p>
      </div>
      <!--      <mat-error *ngIf="!this.reactiveForm.get('file').value">Please choose an image</mat-error>-->
      <button mat-button [disabled]="reactiveForm.invalid || additionnalImage.length<1 || isAdditionalImageUploading"
        style="background: #3C50E0; color: white"
        [ngClass]="{'deactivated': reactiveForm.invalid || additionnalImage.length<1 || isAdditionalImageUploading, 'activated': !reactiveForm.invalid && additionnalImage.length > 0 && !isAdditionalImageUploading}"
        (click)="addMoreImageToFloorPlan()">
        {{isAdditionalImageUploading ? 'Adding image...' : 'Add image'}}
      </button>
    </form>

  </div>
  <div *ngFor="let floorPlan of project.floorPlans"
    style="width: 100%; margin-bottom: 20px; padding: 20px 0; border-top: 1px solid #ebebeb">
    <div style="display: flex; margin-bottom: 10px; align-items: center; justify-content: space-between">
      <div style="display: flex; align-items: center">
        Floorplans
        <input [(ngModel)]="floorPlan.notes"
          style="margin: 8px 8px; padding: 8px; border: 1px solid #DEDEDE; outline: none;background: #0E0D0D;color: #DEDEDE;">
        <button mat-button (click)="editNotes(floorPlan.id, floorPlan.notes)"
          style="margin: 8px 8px;border: 1px solid">Edit</button>
        <button mat-button (click)="openArModelDialog(floorPlan.id)" style="border: 1px solid; margin: 8px 8px;">AR
          model settings</button>
        <span
          *ngIf="isNewNotesValid.id === floorPlan.id && (floorPlan.notes.length === 0 || floorPlan.notes.length > 250)"
          style="color: #f44336; font-size: 14px">Notes length should be 1 - 250.</span>
      </div>
      <button mat-button style="border: 1px solid; margin: 8px 8px;" (click)="deleteFloorPlan(floorPlan.id)">
        Delete floor plan
      </button>
    </div>
    <div fxLayout="row wrap" fxLayoutGap="20px" *ngIf="floorPlan.images">
      <div *ngIf="floorPlan.images.length != 0">
        <div *ngFor="let image of floorPlan.images"
          style="width: 200px; height: 200px; border: 1px solid #ebebeb; display: flex; align-items: flex-end; margin-bottom: 20px; position: relative">
          <img [src]="SERVER_URL + 'images/' + project.projectCode + '/floor_plans/' + image.fileName"
            style="width: 100%; height: 100%; object-fit: contain; position: absolute; top: 0; left: 0">
          <p
            style="z-index: 10; background: rgba(0,0,0,.5); color: white; margin-top: 0; margin-bottom: 0; padding: 10px; width: 100%; display: flex; justify-content: space-between; align-items: center">
            <!--          <span style="font-size: 12px">{{image.fileName}}</span>-->
            <mat-icon style="color: white; cursor:pointer;" (click)="deleteImageFromFloorPlan(floorPlan.id, image.id)">
              delete
            </mat-icon>
          </p>
        </div>
      </div>

      <div *ngIf="floorPlan.images.length === 0">
        <p>No image is included in this floor plan.</p>
      </div>

    </div>
    <div *ngIf="floorPlan.urls&&floorPlan.urls.ios&&floorPlan.urls.android">
      delete AR
      <mat-icon style="color: black; cursor:pointer;" (click)="deleteAr(floorPlan.id)">
        delete
      </mat-icon>
    </div>
  </div>
</div>